import { component } from 'picoapp';
import { gsap } from 'gsap/all';
import { Flip } from 'gsap/Flip';

gsap.registerPlugin(Flip);

class WinnersLoader {
  constructor(el, ctx) {
    this.el = el;
    this.ctx = ctx;
    this.init();
    this.bindEvents();
    this.container = el.querySelector('.Section__content');
    this.increment = el.dataset.increment;
  }

  init() {
    this.trigger = this.el.querySelector('[data-loader-trigger]');
    this.tableRows = Array.from(this.el.querySelectorAll('.Table .Table__body .Table__row'));
  }

  bindEvents() {
    this.trigger.addEventListener('click', () => {

      const hiddenTableRows = this.tableRows.filter(r => r.classList.contains('row-hidden'));

      const containerStartHeight = gsap.getProperty(this.container, "height");

      const rowsToLoad = hiddenTableRows.slice(0, this.increment)

      const state = Flip.getState(rowsToLoad);

      this.showMore(hiddenTableRows, rowsToLoad)

      this.animate(state, containerStartHeight)


    })
  }

  animate(state, containerStartHeight) {

    const containerEndHeight = gsap.getProperty(this.container, "height");

    const transition = Flip.from(state, {
      duration: 0.5,
      ease: "power1.inOut",
      absolute: true,
      onEnter: elements => gsap.fromTo(elements, { opacity: 0, yPercent: -50 }, { opacity: 1, yPercent: 0, stagger: 0.2 }),
      onLeave: elements => gsap.fromTo(elements, { opacity: 1 }, { opacity: 0, stagger: 0.2 })
    })

    //animate loop height on transition
    transition.fromTo(this.container, {
      height: containerStartHeight,
      ease: "power1.inOut",
    }, {
      height: containerEndHeight,
      clearProps: "height",
      ease: "power1.inOut",
      duration: transition.duration()
    }, 0);

  }

  showMore(hiddenTableRows, rowsToLoad) {

    if (rowsToLoad.length) {
      rowsToLoad.forEach(r => r.classList.remove('row-hidden'))
    }

    //HIDES TRIGGER BUTTON IF NO MORE ROWS TO LOAD
    if (hiddenTableRows.length <= rowsToLoad.length) {
      this.trigger.style.visibility = "hidden";
    }

  }
}

export default component((node, ctx) => {
  new WinnersLoader(node, ctx);
});
